import { __awaiter } from "tslib";
import env from '@/env';
import { Self } from '@/vue-core';
import { status } from '@/alas';
import { showError } from '@/store';
import { defineComponent, ref, reactive, onMounted, onUnmounted, computed } from '@vue/composition-api';
export default defineComponent({
    setup(props, context) {
        let self = new Self(context);
        // ================
        //
        // refs
        //
        let farm = ref(status.fetch('farm'));
        let cycle = ref(status.fetch('cycle'));
        let types = ref(status.fetch('types'));
        let config = ref(status.fetch('config'));
        let confirm = ref(null);
        // ================
        //
        // state
        //
        let $ = reactive({
            qrcode: false,
            closeDialog: false,
            closeLevel: 0,
            closeMessage: '',
            selectDay: '',
            pictures: status.fetch('pictures')
        });
        // ================
        //
        // computed
        //
        let type = computed(() => types.value.fetch(cycle.value.type));
        let breed = computed(() => types.value.m.getBreed(cycle.value.type, cycle.value.breed));
        let title = computed(() => type.value ? type.value.name + ' - ' + breed.value.name : '...');
        let isLive = computed(() => cycle.value.finishedAt == null);
        let clientUrl = computed(() => {
            return `${env.clientBaseURL}/farms/${farm.value.id}/cycles/${cycle.value.createdAt}/overview?date=${$.selectDay}`;
        });
        let canClose = computed(() => Date.now() > cycle.value.createdAt + (config.value.cycleClosePreDay * 1000 * 24 * 60 * 60));
        let finish = computed(() => cycle.value.$o.fetch.done && $.pictures.o.fetchArchived.done);
        let subTitle = computed(() => {
            let output = farm.value.name + ' - ';
            if (cycle.value.$v.closed) {
                output += cycle.value.$v.createdAt + ' - ' + cycle.value.$v.finishedAt;
            }
            else {
                output += cycle.value.$v.createdAt + ' - ' + self.t('現在');
            }
            return output + ' - ' + self.t('共') + cycle.value.$v.days + self.t('天');
        });
        let days = computed(() => {
            return $.pictures.v.days;
        });
        // ================
        //
        // mounted
        //
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            yield cycle.value.$o.fetch.seek({
                farmId: self.route.params.id,
                createdAt: self.route.params.cycle
            });
            yield $.pictures.o.fetchArchived.seek({
                farmId: farm.value.id,
                startTime: cycle.value.createdAt,
                finishTime: cycle.value.finishedAt
            });
            $.selectDay = days.value[0];
        }));
        onUnmounted(() => {
            status.reset('cycle');
            status.reset('picture');
            status.reset('pictures');
        });
        // ================
        //
        // methods
        //
        let close = () => {
            cycle.value.$o.close.start({
                level: $.closeLevel,
                message: $.closeMessage
            }).then(() => {
                $.closeDialog = false;
            });
        };
        let remove = () => {
            confirm.value.open((close) => __awaiter(this, void 0, void 0, function* () {
                try {
                    yield cycle.value.$o.remove.start();
                    self.router.push({
                        name: 'farms.overview'
                    });
                }
                catch (error) {
                    showError(error);
                }
                close();
            }));
        };
        let openClose = () => {
            if (canClose.value) {
                $.closeDialog = true;
            }
            else {
                showError(context.root.$t('你等待需要N天才能關閉週期', {
                    day: config.value.cycleClosePreDay
                }));
            }
        };
        let toTGAP = () => {
            window.open(breed.value.tgap, '_break');
        };
        // ================
        //
        // done
        //
        return {
            $,
            farm,
            cycle,
            types,
            config,
            confirm,
            type,
            breed,
            title,
            subTitle,
            isLive,
            clientUrl,
            canClose,
            close,
            remove,
            openClose,
            toTGAP,
            finish,
            days
        };
    }
});
